import { prevArrow, nextArrow } from "../template-parts/card-slider";

jQuery( '.features.features-slider' ).slick( {
  dots: false,
  infinite: true,
  speed: 600,
  cssEase: 'ease',
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: true,
        prevArrow,
        nextArrow
      }
    }
  ]
} );